
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { required } from '@vuelidate/validators';
import { estateAgentReviewService } from './EstateAgentReviewService';
import StarRating from 'vue-star-rating';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import useVuelidate from '@vuelidate/core';

export default defineComponent({
  name: 'EstateAgentReview',
  mixins: [Form],
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    StarRating,
    ResizableImage,
  },
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        token: null as null | undefined | string,
        rating: 0,
        review: null,
      },
      review: null,
      isNotFound: false,
    };
  },
  validations() {
    return {
      form: {
        token: { required },
        rating: {},
        review: {},
      },
    };
  },
  async created() {
    this.startLoading();
    try {
      const result = await estateAgentReviewService.getRequest(this.token);
      this.review = result.data;
      if (!this.review) {
        this.errors = [this.$t('EstateAgentReview.not-found')];
        this.isNotFound = true;
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.endLoading();
    }
  },
  methods: {
    async send() {
      this.form.token = this.token;

      if (!this.validate()) return;

      try {
        await estateAgentReviewService.insert(this.form);
        this.success();
      } catch (error: any) {
        if (error && error.response && error.response.status === 404) {
          this.errors = [this.$t('EstateAgentReview.not-found')];
          this.isNotFound = true;
        } else {
          this.handleApiError(error);
        }
      }
    },
  },
});
